import type { Presentation } from '../../types';
import { ListPresentation } from './ListPresentation';
import { TablePresentation } from './TablePresentation';
import { MapPresentation } from './MapPresentation';
import { ChartPresentation } from './ChartPresentation';
import { ProsePresentation } from './ProsePresentation';
import { StatsPresentation } from './StatsPresentation';
import { CompositePresentation } from './CompositePresentation';
import { StateChoroplethPresentation } from './StateChoroplethPresentation';

interface Props {
  p: Presentation;
}

export function PresentationContainer({ p }: Props) {
  switch (p.type) {
    case 'list':
      return <ListPresentation p={p} />;
    case 'table':
      return <TablePresentation p={p} />;
    case 'map':
      return <MapPresentation p={p} />;
    case 'chart':
      return <ChartPresentation p={p} />;
    case 'state_choropleth':
      return <StateChoroplethPresentation p={p} />;
    case 'stats':
      return <StatsPresentation p={p} />;
    case 'composite':
      return <CompositePresentation p={p} />;
    case 'prose':
      return <ProsePresentation p={p} />;
    default:
      // Exhaustiveness check — TS will flag if a new variant is added without
      // a case here.
      return <pre className="presentation-debug">{JSON.stringify(p, null, 2)}</pre>;
  }
}
